import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../lib/auth';

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { refresh } = useAuth();
  const [error, setError] = useState('');
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav('/', { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id });
        if (data.session_token) localStorage.setItem('pc_session_token', data.session_token);
        // Hydrate auth context BEFORE navigating, otherwise ProtectedRoute will bounce.
        await refresh();
        const dest = data.user?.role === 'super_admin' ? '/admin' : '/dashboard';
        window.history.replaceState({}, document.title, dest);
        nav(dest, { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || e.message || 'Authentication failed');
      }
    })();
  }, [loc, nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center p-10">
      <div className="text-center">
        <div className="label-mono mb-3">PackCheck / Authentication</div>
        {!error ? (
          <>
            <div className="text-2xl font-medium">Signing you in…</div>
            <div className="dot-loader mt-6"><span /><span /><span /></div>
          </>
        ) : (
          <>
            <div className="text-2xl font-medium text-destructive">Sign-in failed</div>
            <div className="mt-3 text-sm text-muted-foreground">{error}</div>
            <a href="/" className="mt-6 inline-block underline">Return home</a>
          </>
        )}
      </div>
    </div>
  );
}
